module.exports = __webpack_public_path__ + "media/images/icons/chat-left-arrow-d97ab294fc0169e899135b524d766859.svg";